import React from 'react';
import { ModalComponentProps } from '@mc/react-core';
import { FormRenderProps } from 'react-final-form';
import { CloseButton } from '../button/CloseButton';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { DialogFooter } from '../dialog/DialogFooter';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { Button } from '../button/Button';
import { modalFormDialog } from '../form/utils';
import { Block, Card, VF } from '../../src';
import { TableSettingsEnumType } from './types';
import { makeValidate } from '@mc/react-final-form';
import { Yup } from '../validation/yup';

type FormValues = {
  nazev: string;
};
type Props = {
  formRenderProps: FormRenderProps<FormValues>;
  type: TableSettingsEnumType;
} & ModalComponentProps;

const validate = makeValidate(
  Yup.object().shape({
    nazev: Yup.string().required(),
  })
);

const SaveByNameModal = ({
  formRenderProps: { handleSubmit, submitting },
  type,
  onClose,
}: Props) => {
  return (
    <Dialog onClose={onClose} title={`Uložit jako nový ${type}`}>
      <DialogBody>
        <Card mode={'edit'}>
          <Block>
            <VF.String
              required
              disabled={submitting}
              label={`Název ${type}u`}
              name="nazev"
            />
          </Block>
        </Card>
      </DialogBody>
      <DialogFooter>
        <ButtonToolbar>
          <CloseButton disabled={submitting} onClick={onClose}>
            Zrušit
          </CloseButton>
          <Button
            style={'primary'}
            disabled={submitting}
            onClick={handleSubmit}
            dataTest={'submit'}
          >
            Uložit
          </Button>
        </ButtonToolbar>
      </DialogFooter>
    </Dialog>
  );
};

export const SaveByNameModalForm =
  // @ts-ignore
  modalFormDialog<FormValues, Props>(SaveByNameModal, { validate });
